import { render, staticRenderFns } from "./Point.vue?vue&type=template&id=0966c25e&scoped=true&"
import script from "./Point.vue?vue&type=script&lang=ts&"
export * from "./Point.vue?vue&type=script&lang=ts&"
import style0 from "./Point.vue?vue&type=style&index=0&id=0966c25e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0966c25e",
  null
  
)

export default component.exports